exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#spacer{padding-top:4.5em}textarea{line-height:200%;padding-left:0}#woAdmissionInfo,textarea{border:0 none #fff;overflow:hidden;outline:none;background-color:transparent;font-family:Verdana,Arial,Tahoma}#woAdmissionInfo{white-space:pre-line}#spacer{padding-top:2.5em}#smspacer{padding-top:2em}#xsmspacer{padding-top:1.5em}#xxsmspacer{padding-top:.5em}#woMain{margin:5px 3em;border:0;width:60em}#woRpt{width:29.2em}#woRpt,#woSI{vertical-align:left;text-align:left;float:left}#woSI{width:90%;padding-bottom:5px}span{font-weight:700}#woRpt-long{width:65.2em}#woRpt-left,#woRpt-long{vertical-align:left;text-align:left;float:left}#woRpt-left{width:15.2em}#woRpt-full{width:100%}#woHeader,#woRpt-full{vertical-align:left;text-align:left;float:left}#woHeader{width:50.2em;font-weight:700}hr{float:left;width:67rem;margin:5px 3em}@media print{.page-break{display:block;page-break-before:always}}section.hidden{display:none}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/workOrderReport/WorkOrderReport.component.scss
// module id = ./src/app/workOrderReport/WorkOrderReport.component.scss
// module chunks = app